// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Drawer that displays a return order's audit log — the chronological list
 * of lifecycle, field-edit, and third-party events recorded for the order.
 */
import { AuditDrawer } from '@/components/audit-drawer';
import { ReturnOrderAuditList } from '@/return-order/components/return-order-audit-list';

interface Props {
  returnOrderKey: string;
  disclosure: {
    isOpen: boolean;
    open: () => void;
    close: () => void;
  };
}

export function ReturnOrderAuditDrawer(props: Props) {
  return (
    <AuditDrawer
      title="Return order audit log"
      disclosure={props.disclosure}
      auditLog={<ReturnOrderAuditList returnOrderKey={props.returnOrderKey} />}
    />
  );
}
